import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";

import "./createClient.css";

import {
  createUserFormValidate,
  editUserFormValidate,
} from "../../../../helper/validate";
import * as api from "helper/helper";
import invalidClass from "../../helperFunctions/helpers";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import LoadingButton from "../LoadingButton/LoadingButton";

import { Singleton } from "helper/tools";
import { format } from "date-fns";
import { CurrencyInput } from "components/CurrencyInput";

export const PagoModalMode = Object.freeze({
  Producto: "PRODUCTO",
  Cliente: "CLIENTE",
  Asociado: "ASOCIADO",
});

/// renders
const CreateConvenio = forwardRef(
  (
    {
      reloadCobranza,
      cobranzaItem,
      productoParcialidad,
      asociadoId,
      cobranzaInfoDetail,
      interestItem,
      pagoModalMode = PagoModalMode.Producto,
    },
    ref,
  ) => {
    const modalRef = useRef();
    const buttonCancelModalRef = useRef();

    const [isActiveDisabled, setIsActiveDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [parcialidadActual, setParcialidadActual] = useState(null);
    const [nuevoAdeudo, setNuevoAdeudo] = useState(0);

    const [allItems, setAllItems] = useState(null);
    const [adeudoQuincenal, setAdeudoQuincenal] = useState(0);
    const [usedAmount, setUsedAmount] = useState(0);

    const [totalAplicar, setTotalAplicar] = useState(0);
    const [invalidEntrante, setInvalidEntrante] = useState(false);

    const [canSave, setCanSave] = useState(false);

    const [canAdeudoQuincenal, setCanAdeudoQuincenal] = useState(false);
    const [adeudoQuincenalChecked, setAdeudoQuincenalChecked] = useState(false);
    const [errorOtroAmount, setErrorOtroAmount] = useState("");

    const [numeroQuincenas, setNumeroQuincenas] = useState(1);
    const [fechasCorte, setFechasCorte] = useState(null);
    const [selectedFechaCorte, setSelectedFechaCorte] = useState(null);
    const [fechasCorteResultado, setFechasCorteResultado] = useState(null);
    const [abonosInfo, setAbonosInfo] = useState(null);

    const [errorProductosAmount, setErrorProductosAmount] = useState([]);
    const [initialValues, setInitialValues] = useState({
      entrante: 0,
      productosAbonos: [],
    });

    const [otroChecked, setOtroChecked] = useState(false);

    const [permissions, setPermissions] = useState({
      canCreate: false,
      canEdit: false,
      canVerDetalle: true,
    });

    const isSaveDisable = useRef();
    const fieldsSetup = useRef({});

    const createMode = true; //item == null || (item && Object.keys(item).length === 0);

    useEffect(() => {
      console.log("---> change item: CREATEPAGO ");

      if (pagoModalMode === PagoModalMode.Producto) {
        if (
          cobranzaItem == null ||
          (productoParcialidad == null && interestItem == null)
        ) {
          return;
        }

        let isActiveDisable = true;
        if (!createMode) {
          isActiveDisable = false;
        }
        setIsActiveDisabled(isActiveDisable);

        formik?.resetForm();

        setupFields();

        isSaveDisable.current =
          (createMode && !permissions.canCreate) ||
          (!createMode && !permissions.canEdit);

        //
        if (productoParcialidad) {
          let currentParcialidad = productoParcialidad?.parcialidades.find(
            (e) =>
              e.parcialidadNumero === productoParcialidad?.parcialidadNumero,
          );

          let abono = currentParcialidad.total;
          abono = Singleton.getInstance().format(abono);

          let pagado = Singleton.getInstance().format(
            productoParcialidad.totalPagado,
          );

          let debe = Singleton.getInstance().format(
            productoParcialidad.totalPendiente,
          );
          /*
           */

          /*let kurrent = Singleton.getInstance().format(
        currentParcialidad?.totalPagado ?? 0,
      );*/

          /*let adeudoQuincenal = Singleton.getInstance().format(
        productoParcialidad?.subPagoProductoAdicional?.total ?? 0,
      );*/
          //interestItem

          const newParcialidadActual = productoParcialidad.parcialidades.find(
            (e) =>
              e.parcialidadNumero === productoParcialidad.parcialidadNumero,
          );

          setParcialidadActual(newParcialidadActual);

          // preselectst
          const enableAdeudoQuincenal =
            cobranzaInfoDetail?.disponible >
            newParcialidadActual?.totalPendiente;
          setCanAdeudoQuincenal(!enableAdeudoQuincenal);
          setAdeudoQuincenalChecked(enableAdeudoQuincenal);

          setOtroChecked(!enableAdeudoQuincenal);

          setAdeudoQuincenal(parcialidadActual?.totalPendiente ?? 0);
        } else if (interestItem) {
          setParcialidadActual(null);

          // preselectst
          const enableAdeudoQuincenal =
            cobranzaInfoDetail?.disponible > interestItem?.totalPendiente;
          setCanAdeudoQuincenal(!enableAdeudoQuincenal);
          setAdeudoQuincenalChecked(enableAdeudoQuincenal);

          setOtroChecked(!enableAdeudoQuincenal);

          setAdeudoQuincenal(interestItem?.totalPendiente ?? 0);
        }
      } else if (pagoModalMode === PagoModalMode.Cliente) {
        //
        let accumulator = 0;
        let countItems = 0;
        let newAllItems = [];
        //  let saldoAlCorte = 0;
        //    let totalAPagar = 0;
        cobranzaItem.ordenParcialidades.forEach((ordenParcialidad) => {
          //
          ordenParcialidad.productoParcialidades.forEach(
            (productoParcialidad) => {
              const parcialidadActual = productoParcialidad.parcialidades.find(
                (e) =>
                  e.parcialidadNumero === productoParcialidad.parcialidadNumero,
              );
              if (parcialidadActual) {
                accumulator += parcialidadActual.totalPendiente;
                countItems += 1;

                newAllItems.push({
                  parcialidadActual,
                  producto: productoParcialidad.ordenVentaDetalle.producto,
                  productoParcialidad: productoParcialidad,
                  type: "producto",
                });
              }
            },
          );
          //
        });

        if (cobranzaItem.interestItems?.length > 0) {
          newAllItems.push(...cobranzaItem.interestItems);
        }
        countItems += cobranzaItem.interestItems.length;
        accumulator += cobranzaItem.interestItems.reduce(
          (accumulator, interestItem) => {
            return accumulator + interestItem.totalPendiente;
          },
          0,
        );

        console.log("---");

        setAllItems(newAllItems);

        setAdeudoQuincenal(accumulator);

        const enableAdeudoQuincenal =
          cobranzaInfoDetail?.disponible > accumulator;
        setCanAdeudoQuincenal(!enableAdeudoQuincenal);
        setAdeudoQuincenalChecked(enableAdeudoQuincenal);

        setOtroChecked(!enableAdeudoQuincenal);

        let newInitialValues = { ...initialValues };
        newInitialValues.productosAbonos = new Array(countItems).fill(0);
        setInitialValues(newInitialValues);

        setErrorProductosAmount(new Array(countItems).fill(""));

        setTotalAplicar(0);

        setInvalidEntrante(false);
      }

      updateCanSave();

      setIsActiveDisabled(!isActiveDisabled);

      //--

      console.log("--ll");
    }, [cobranzaItem, productoParcialidad, interestItem]);

    useEffect(() => {
      formik?.resetForm();

      const newPermissions = PermissionsForSection(Sections.Clientes);
      setPermissions(newPermissions);
    }, []);

    useEffect(() => {
      updateCanSave(usedAmount);
    }, [adeudoQuincenalChecked, otroChecked, usedAmount, totalAplicar]);

    useEffect(() => {
      loadFechaAndParcialidades();
    }, [numeroQuincenas, selectedFechaCorte]);

    useEffect(() => {
      calculateAbonos();
    }, [nuevoAdeudo, fechasCorteResultado]);

    /*  let initialValues = {
      entrante: 0,
      productosAbonos: [],
    };*/

    async function loadAvailableDates() {
      /*
    default traer las primeras 8
    */
      const ParcialidadesNo = 2;

      setIsLoading(true);
      /*const toastId = toast.loading(
                              "Creando Orden de Venta...",
                            );*/
      let response = await api
        .demoParcialidades({
          noParcialidades: ParcialidadesNo,
        })
        .catch((e) => {
          //    toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

      setIsLoading(false);
      //toast.dismiss(toastId);

      if (!response) return;

      setFechasCorte(response.data);

      //  toast.success("Orden de Venta creado.");
    }

    async function loadFechaAndParcialidades() {
      if (selectedFechaCorte == null) return;
      if (numeroQuincenas == null) return;

      setIsLoading(true);
      /*const toastId = toast.loading(
                              "Creando Orden de Venta...",
                            );*/
      let response = await api
        .demoParcialidades({
          noParcialidades: numeroQuincenas,
          startDate: selectedFechaCorte,
        })
        .catch((e) => {
          //    toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

      setIsLoading(false);
      //toast.dismiss(toastId);

      if (!response) return;

      setFechasCorteResultado(response.data);

      //TODO checa calculateAbonos();

      //  toast.success("Orden de Venta creado.");
    }

    function calculateAbonos() {
      if (fechasCorteResultado == null) return;
      const abono = nuevoAdeudo / (numeroQuincenas > 0 ? numeroQuincenas : 1);

      const resu = fechasCorteResultado.map((fechaCorte, index) => {
        fechaCorte.start = fechaCorte.start.replace("Z", "");

        const debe = nuevoAdeudo - abono * (index + 1);

        return {
          ...fechaCorte,
          abono: abono,
          debe: debe,
        };
      });

      setAbonosInfo(resu);
    }

    const formik = useFormik({
      initialValues,
      enableReinitialize: true,
      validate: createMode ? createUserFormValidate : editUserFormValidate,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (valuesSource) => {},
    });

    useImperativeHandle(ref, () => ({
      getValue: () => {
        return formik.values;
      },
      toggleModal: () => {
        formik?.resetForm();
        modalRef.current.click();

        loadAvailableDates();

        /*      let initialValues = {
      entrante: 0,
      productosAbonos: [],
    };
*/
        setInitialValues({
          entrante: 0,
          productosAbonos: [],
        });

        //clear
        //const [canSave, setCanSave] = useState(false);

        //const [canAdeudoQuincenal, setCanAdeudoQuincenal] = useState(false);
        //const [adeudoQuincenalChecked, setAdeudoQuincenalChecked] = useState(false);
        setErrorOtroAmount("");

        //const [otroChecked, setOtroChecked] = useState(false);
      },
    }));

    /** manage address add/edit */
    function setupFields() {
      // fieldsSetup
      fieldsSetup.current = {};

      for (const [key, value] of Object.entries(initialValues)) {
        console.log(`${key}: ${value}`);

        const res = api.isFieldReadOnlyWith(createMode, value);
        fieldsSetup.current[key] = res;
      }
    }

    function updateCanSave(entranteVal = null) {
      let canSave = false;

      if (pagoModalMode === PagoModalMode.Producto) {
        if (productoParcialidad) {
          if (adeudoQuincenalChecked) {
            canSave = (parcialidadActual?.totalPendiente ?? 0) > 0;
          } else if (otroChecked) {
            let num = 0;
            if (entranteVal) {
              num = parseFloat(entranteVal);
            } else {
              num = parseFloat(formik.values.entrante);
            }
            canSave = num > 0 && num <= cobranzaInfoDetail?.disponible;
          }
        } else if (interestItem) {
          if (adeudoQuincenalChecked) {
            canSave = (interestItem?.totalPendiente ?? 0) > 0;
          } else if (otroChecked) {
            let num = 0;
            if (entranteVal) {
              num = parseFloat(entranteVal);
            } else {
              num = parseFloat(formik.values.entrante);
            }
            canSave = num > 0 && num <= cobranzaInfoDetail?.disponible;
          }
        }
      } else if (pagoModalMode === PagoModalMode.Cliente) {
        /*
        - Seleccionado un check Otro
          > Otro  
            - debe ser mayor de 0
            - numero no debe ser mayor a lo que esta en Debe porductoparcialidades
            - la suma de cada fila no debe pasar a la cantidad disponible
         */
        if (otroChecked && totalAplicar > 0) {
          canSave = totalAplicar <= cobranzaInfoDetail?.disponible;
          if (totalAplicar > cobranzaInfoDetail?.disponible) {
            canSave = false;
          }
        } else if (adeudoQuincenalChecked) {
          canSave = adeudoQuincenal < cobranzaInfoDetail?.disponible;
        }
      }

      setCanSave(canSave);

      const showErrorAmount =
        usedAmount > cobranzaInfoDetail?.disponible
          ? "Cantidad se excede al saldo disponible"
          : "";
      setErrorOtroAmount(showErrorAmount);
    }

    function amountToSave() {
      let amount = 0;
      if (adeudoQuincenalChecked) {
        if (parcialidadActual != null) {
          amount = parcialidadActual.totalPendiente;
        } else if (interestItem == null) {
          amount = interestItem.totalPendiente;
        } else {
          console.log("--> INVALID parcialidadNumero");
          return;
        }
      } else if (otroChecked) {
        amount = formik.values.entrante;
      }
      return amount;
    }

    const totalPendiente = Singleton.getInstance().format(
      cobranzaItem?.total ?? 0,
    );

    return (
      <>
        <button
          ref={modalRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#staticBackdropCrearConvenio"
          hidden
        >
          Abrir Crear Abono
        </button>
        <div
          className="modal fade modal-sms"
          id="staticBackdropCrearConvenio"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropCrearConvenioLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="staticBackdropCrearConvenioLabel"
                >
                  {createMode ? "Crear" : "Editar"} Convenio
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => {
                    //if (returnBack != null) returnBack();
                  }}
                  disabled={isLoading}
                ></button>
              </div>

              <div className="modal-body">
                <form
                  className="row g-3"
                  onSubmit={(event) => {
                    event.preventDefault();
                    return false;
                  }}
                >
                  <div className="bd-example-row1">
                    <div className="row">
                      <ul className="list-group">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Adeudo Total
                          <span className="badge text-bg-warning rounded-pill fs-6">
                            {totalPendiente}
                          </span>
                        </li>
                      </ul>

                      <div className="row">
                        <label
                          className="form-check-label"
                          style={{ marginTop: "20px", marginBottom: "10px" }}
                        >
                          Configurar convenio:
                        </label>
                      </div>

                      <ul className="list-group my-3">
                        <li className="list-group-item d-flex justify-content-between align-items-center">
                          Nuevo Adeudo
                          <CurrencyInput
                            initialValue={nuevoAdeudo}
                            value={nuevoAdeudo}
                            className={`badge text-bg-info rounded-pill fs-6 d-flex text-center ${invalidClass()}`}
                            style={{
                              width: "180px",
                            }}
                            placeholder="Cantidad a Agregar"
                            onNewValueHandler={(p) => {
                              //  console.log(p);
                              //  formik.setFieldValue("entrante", p);
                              setNuevoAdeudo(p);
                            }}
                          />
                          {/** }  <span className="badge text-bg-warning rounded-pill fs-6">
                            {totalPendiente}
                          </span> */}
                        </li>
                      </ul>

                      <div className="form-floating mb-3 col">
                        <input
                          type="number"
                          min="1"
                          max="24"
                          className={`form-control ${invalidClass([])}`}
                          value={numeroQuincenas}
                          style={{ textAlign: "center" }}
                          id="floatingInput"
                          aria-describedby="emailHelp"
                          onKeyDown={(e) => {
                            // Prevent typing decimals, commas, or exponents directly
                            if ([".", ",", "e", "E"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={async (e) => {
                            const value = e.currentTarget.value;
                            //  setNumeroQuincenas(value);

                            //(e) => {
                            const inputValue = e.target.value;

                            // 1. Allow empty input so users can delete their text
                            if (inputValue === "") {
                              setNumeroQuincenas("");
                              return;
                            }

                            // 2. Convert to integer
                            const parsedValue = Number.parseInt(inputValue, 10);
                            setNumeroQuincenas(parsedValue);

                            /*
                            // 3. Only update state if the number is even
                            if (
                              !Number.isNaN(parsedValue) &&
                              parsedValue % 2 === 0
                            ) {
                              setNumeroQuincenas(parsedValue);
                            }
                            //}
                            */
                          }}
                          disabled={false}
                        />

                        <label htmlFor="floatingInput">
                          Número de quincenas
                        </label>
                      </div>

                      <div className="form-floating col">
                        <select
                          className="form-select"
                          id="floatingSelect"
                          aria-label="Floating label example"
                          onChange={(item) => {
                            const value = item.currentTarget.value;
                            setSelectedFechaCorte(value);
                          }}
                        >
                          <option value="" selected disabled hidden>
                            -
                          </option>
                          {fechasCorte?.map((fechaCorte, index) => {
                            //  const startRaw = fechaCorte.start.replace("Z", "");

                            const start = format(
                              fechaCorte.start,
                              "yyyy-MM-dd",
                            );

                            //  const end = format(fechaCorte.end, "yyyy-MM-dd");
                            const selected = fechaCorte?.selected ?? false;
                            return (
                              <option
                                key={start}
                                value={start}
                                selected={selected}
                                onChange={(item) => {
                                  const newFechasCorte = [...fechasCorte];
                                  newFechasCorte.forEach(
                                    (fechaCorte, currIndex) => {
                                      fechaCorte.selected = currIndex === index;
                                      if (fechaCorte.selected) {
                                        setSelectedFechaCorte(fechaCorte);
                                      }
                                    },
                                  );
                                }}
                              >
                                {start}
                              </option>
                            );
                          })}
                        </select>
                        <label htmlFor="floatingSelect">
                          Fecha de Corte Disponibles
                        </label>
                      </div>

                      <ul className="list-group">
                        <li className="list-group-item d-flex flex-column justify-content-between align-items-center1 row-gap-2">
                          <div className="form-check">
                            {fechasCorteResultado && (
                              <table className="table table-dark table-striped">
                                <thead>
                                  <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Inicio</th>
                                    <th scope="col">Abono</th>
                                    <th scope="col">Debe</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {abonosInfo?.map((abonoInfo, index) => {
                                    const start = format(
                                      abonoInfo.start,
                                      "yyyy-MM-dd",
                                    );

                                    const abono =
                                      Singleton.getInstance().format(
                                        abonoInfo.abono,
                                      );

                                    const debe = Singleton.getInstance().format(
                                      abonoInfo.debe,
                                    );

                                    return (
                                      <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{start}</td>
                                        <td>{abono}</td>
                                        <td>{debe}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  ref={buttonCancelModalRef}
                  onClick={(e) => {
                    //  if (returnBack != null) returnBack();
                  }}
                  disabled={isLoading}
                >
                  Cancelar
                </button>
                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={async (e) => {
                    formik.handleSubmit();
                    // Fetch all the forms we want to apply custom Bootstrap validation styles to

                    let extraInfo = {};
                    if (cobranzaItem.cliente) {
                      extraInfo = { clienteId: cobranzaItem.cliente.id };
                    } else if (cobranzaItem.cliente == null) {
                      extraInfo = { clienteId: cobranzaItem.cliente.id };
                    }

                    //TEMP
                    //  const formaDePagoSelected = 1;
                    let response = null;
                    if (pagoModalMode === PagoModalMode.Producto) {
                      const porPagar = amountToSave();
                      if (parcialidadActual == null && interestItem == null) {
                        console.log("--> INVALID parcialidadNumero");
                        return;
                      }

                      setIsLoading(true);

                      response = await api
                        .createSubPago({
                          pagoId: asociadoId,
                          parcialidadId: parcialidadActual?.id,
                          interesParcialidadId: interestItem?.id,
                          Total: porPagar,
                          ...extraInfo,
                        })
                        .catch((e) => {
                          toast.error("Error al crear SubPago.");
                        });
                    } else if (pagoModalMode === PagoModalMode.Cliente) {
                      setIsLoading(true);

                      /*
    public int? InteresParcialidadId { get; set; }
        public int? ParcialidadId { get; set; }
        public decimal? Total { get; set; }
        */
                      let infos = [];
                      if (adeudoQuincenalChecked) {
                        allItems.forEach((aItem, index) => {
                          let interesParcialidadId = null;
                          let parcialidadId = null;
                          let total = aItem?.parcialidadActual?.totalPendiente;

                          if (aItem.parcialidadActual != null) {
                            parcialidadId = aItem.parcialidadActual.id;
                          } else {
                            total = aItem?.totalPendiente;
                            interesParcialidadId = aItem.id;
                          }

                          infos.push({
                            interesParcialidadId: interesParcialidadId,
                            parcialidadId: parcialidadId,
                            total: total,
                          });
                        });
                      } else if (otroChecked) {
                        allItems.forEach((aItem, index) => {
                          const productosAbonos = formik.values.productosAbonos;

                          let interesParcialidadId = null;
                          let parcialidadId = null;
                          let total = parseFloat(productosAbonos[index]);

                          //  let totalPendiente =
                          //  aItem?.totalPendiente;
                          if (aItem.parcialidadActual != null) {
                            parcialidadId = aItem.parcialidadActual.id;
                          } else {
                            interesParcialidadId = aItem.id;
                          }

                          infos.push({
                            interesParcialidadId: interesParcialidadId,
                            parcialidadId: parcialidadId,
                            total: total,
                          });

                          /*  let newTotalPendiente = value;
                                      if (newTotalPendiente > totalPendiente) {
                                        newTotalPendiente = totalPendiente;
                                      }

                                      newUsedAmount += newTotalPendiente;

                                      productosAbonos[index] =
                                        newTotalPendiente;*/
                        });
                      }

                      response = await api
                        .clienteProrrateo({
                          asociadoId: asociadoId,
                          clienteId: extraInfo.clienteId,
                          info: infos,
                        })
                        .catch((e) => {
                          toast.error(
                            "Error al aplicar prorrateo a Cliente!" /*, {
                                id: toastId,
                              }*/,
                          );
                        });
                    }

                    setIsLoading(false);
                    if (!response) return;

                    setTimeout(() => {
                      reloadCobranza?.();

                      buttonCancelModalRef.current.click();
                    }, 500);

                    //-
                  }}
                  text={"Guardar"}
                  loadingText={"Guardando..."}
                  isLoading={isLoading}
                  isDisable={!canSave}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default CreateConvenio;
